var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"city-code"},_vm._l((_vm.cityCodeComponents),function(item,key){return _c('div',{key:key},[(item.rName === _vm.$route.name)?_c(item.cName,{tag:"component"}):_vm._e()],1)}),0)
}
var staticRenderFns = []

export { render, staticRenderFns }